import { EventType, KnownMembership, MatrixEvent, Room } from 'matrix-js-sdk/src/matrix';

/**
 * BUG-065 / #8198 — Earliest `m.room.member` transition into `join` for `userId`.
 * `room.getMember(userId).events.member.getTs()` reflects the *latest* profile
 * update (join→join), which incorrectly treats post-join meeting lifecycle events
 * as pre-join noise when filtering previews.
 */
export const getMyOriginalJoinTimestamp = (
  room: Room,
  userId: string | null | undefined,
  events?: MatrixEvent[]
): number => {
  if (!userId) return 0;

  const timeline = events ?? room.getLiveTimeline?.()?.getEvents?.() ?? [];
  let firstJoinTs = 0;

  for (const event of timeline) {
    if (event.getType() !== EventType.RoomMember) continue;
    if (event.getStateKey() !== userId) continue;

    const membership = event.getContent()?.membership as KnownMembership | undefined;
    const prevMembership = event.getPrevContent()?.membership as KnownMembership | undefined;
    if (membership !== KnownMembership.Join || prevMembership === KnownMembership.Join) continue;

    const ts = event.getTs();
    if (firstJoinTs === 0 || ts < firstJoinTs) firstJoinTs = ts;
  }

  if (firstJoinTs > 0) return firstJoinTs;

  const member = room.getMember(userId);
  if (!member || member.membership !== KnownMembership.Join) return 0;
  return member.events?.member?.getTs() ?? 0;
};
